import { SvgIcon, SxProps } from "@mui/material";
import CircleSvg from "jsx:../../../Images/Icons/FontAwesome/light/circle.svg";

export function CircleIcon(props: SxProps) {
    return <SvgIcon component={CircleSvg} inheritViewBox sx={props} />;
}
